import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { OAUTH_CALLBACK_PATH } from './config';
import OAuthCallback from './pages/OAuthCallback';
import PluginHostPage from './pages/PluginHostPage';
import PluginsPage from './pages/PluginsPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* The callback must render outside the auth gate: there is no token yet. */}
        <Route path={OAUTH_CALLBACK_PATH} element={<OAuthCallback />} />
        <Route
          path="/*"
          element={
            <AuthProvider>
              <Routes>
                <Route path="/" element={<PluginsPage />} />
                <Route path="/plugins/:id" element={<PluginHostPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
